/* Returns links + pop-up wording. Additive.
   1) Styles every Start a Return / returns portal link so it LOOKS like a link.
   2) In the Returns & Exchanges pop-up (which prints the store Refund policy): turns the plain-text
      Start a Return address into a hyperlink, adds a Start a Return button, and updates the wording to
      match the returns page (first-time customer courtesy; team reviews every request). */
(function () {
  var URL = '/pages/start-a-return';
  var NEEDLE = 'aleadingrole.com/pages/start-a-return';
  var SWAPS = [
    ['waived on your first order with us', 'waived as a courtesy for first-time customers'],
    [' Your return is confirmed on the spot, and where a prepaid label applies it arrives by email straight away. There is no authorization number to wait for.',
     ' Our team reviews your request and replies by email. We proceed once it is accepted, and where a prepaid label applies it follows after acceptance.']
  ];
  var st = document.createElement('style');
  st.textContent =
    'a[href*="start-a-return"]{color:#5B1220 !important;text-decoration:underline !important;text-underline-offset:3px;font-weight:600;cursor:pointer}' +
    'a[href*="start-a-return"]:hover{color:#C9A227 !important}' +
    '#MainContent a[href*="/pages/returns"],#modal-returns .p-body a{color:#5B1220;text-decoration:underline;text-underline-offset:3px}';
  document.head.appendChild(st);
  function fix() {
    var body = document.querySelector('#modal-returns .p-body');
    if (!body || body.getAttribute('data-alr-links') === '1') return;
    var w = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, null);
    var n, list = [];
    while ((n = w.nextNode())) {
      for (var k = 0; k < SWAPS.length; k++) {
        if (n.nodeValue.indexOf(SWAPS[k][0]) > -1) n.nodeValue = n.nodeValue.split(SWAPS[k][0]).join(SWAPS[k][1]);
      }
      if (n.parentNode && n.parentNode.closest && n.parentNode.closest('a')) continue;
      if (n.nodeValue.toLowerCase().indexOf(NEEDLE) > -1) list.push(n);
    }
    list.forEach(function (t) {
      var s = t.nodeValue, i = s.toLowerCase().indexOf(NEEDLE);
      var start = i, label = 'Start a Return';
      var lead = 'Start online at ';
      if (i >= lead.length && s.slice(i - lead.length, i).toLowerCase() === lead.toLowerCase()) {
        start = i - lead.length; label = 'Start a Return online';
      }
      var before = s.slice(0, start), after = s.slice(i + NEEDLE.length);
      var a = document.createElement('a');
      a.href = URL; a.textContent = label;
      var p = t.parentNode;
      if (before) p.insertBefore(document.createTextNode(before), t);
      p.insertBefore(a, t);
      p.insertBefore(document.createTextNode(after), t);
      p.removeChild(t);
    });
    if (!body.querySelector('.alr-start-return')) {
      var d = document.createElement('p');
      d.className = 'alr-start-return';
      d.innerHTML = '<a class="btn gold" href="' + URL + '" style="display:inline-block;text-decoration:none;color:inherit">Start a Return</a>';
      body.insertBefore(d, body.firstChild);
    }
    body.setAttribute('data-alr-links', '1');
  }
  function init() {
    fix();
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-modal="returns"]')) setTimeout(fix, 0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
